import {Component, Input, OnInit, ChangeDetectorRef} from '@angular/core';
import {OrderDetails, ServiceProviderResponseModel} from 'src/app/shared/models';
import {Price} from 'src/app/shared/models/price.model';
import {ProductModel} from '../../../shared/models/product.model';
import {ShippingService} from '../shipping.service';

@Component({
   selector: 'app-shipping-summary',
   templateUrl: './shipping-summary.component.html',
   styleUrls: ['./shipping-summary.component.scss'],
})
export class ShippingSummaryComponent implements OnInit {
   @Input() order!: OrderDetails;
   @Input() option!: Price;
   @Input() providerData: ServiceProviderResponseModel;

   translatePath = 'public.shipping-summary.';
   groupByProducts: Array<Array<ProductModel>>;
   formError = false;

   constructor(private shippingService: ShippingService, private cdr: ChangeDetectorRef) {}

   params: any;

   ngOnInit(): void {
      if (this.providerData?.products.length > 1) {
         this.groupByProducts = this.groupBy(this.providerData?.products, 'code');
      } else {
         this.groupByProducts = new Array<Array<ProductModel>>(this.providerData?.products);
      }
   }

   submit() {}
   groupBy = (array: any[], key: string | number) => {
      return array.reduce((result, currentValue) => {
         (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
         return result;
      }, []);
   };
   getSubtotal() {
      if (!this.providerData?.products) {
         return 0;
      } else {
         let subtotal = 0;
         this.providerData.products.forEach((item) => (subtotal += item.price));
         return subtotal;
      }
   }

   getTotalPrice() {
      if (!this.providerData?.products) {
         return;
      } else {
         let total = this.getSubtotal();
         return (total + (this.option ? this.option.cost : 0)).toFixed(2);
      }
   }
}
